// @flow
import type { IntlShape } from 'react-intl';

import type { Role } from 'state/types';
import localizedStrings from 'util/localizedStrings';

export const NAME_READER = 'Reader';
export const NAME_EDITOR = 'Editor';
export const NAME_PUBLISHER = 'Publisher';
export const NAME_ADMIN = 'Catalog Administrator';

const BUILTIN_ROLE_NAMES = [
  NAME_ADMIN,
  NAME_EDITOR,
  NAME_READER,
  NAME_PUBLISHER,
];

export function isRoleCustom(role: ?Role) {
  return role && !BUILTIN_ROLE_NAMES.includes(role.name);
}

export function roleOrder(roleName: ?string) {
  switch (roleName) {
    case NAME_READER:
      return 1;
    case NAME_EDITOR:
      return 2;
    case NAME_PUBLISHER:
      return 3;
    case NAME_ADMIN:
      return 4;
    case '': // Users without a role get assigned empty string
      return 10;
    default:
      return 9;
  }
}

export function sortRoles(inputRoles: Role[]): Role[] {
  return inputRoles.sort((a, b) => {
    const sortOrder = roleOrder(a.name) - roleOrder(b.name);
    return sortOrder === 0 ? a.name.localeCompare(b.name) : sortOrder;
  });
}

export function getLocalizedRoleName(intl: IntlShape, roleName: string) {
  const { formatMessage } = intl;
  switch (roleName) {
    case NAME_ADMIN:
      return formatMessage(localizedStrings.USER_LEVEL_ADMINISTRATOR);
    case NAME_PUBLISHER:
      return formatMessage(localizedStrings.USER_LEVEL_PUBLISHER);
    case NAME_EDITOR:
      return formatMessage(localizedStrings.USER_LEVEL_EDITOR);
    case NAME_READER:
      return formatMessage(localizedStrings.USER_LEVEL_READER);
    default:
      return roleName;
  }
}

export function getRoleForUUID(roles: Role[], uuid: string): ?Role {
  return roles.find(r => r.uuid === uuid);
}



// WEBPACK FOOTER //
// ./src/util/roleUtils.js